module.exports = __webpack_public_path__ + "static/media/about-img-9@2x.3fb797c1.png";